import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { formatTime, inputTimeToDecimal } from 'app/shared/time';
import { AlertService } from 'app/core/alerts/alert.service';
import { ConfirmService } from 'app/shared/confirm-dialog/confirm-dialog.service';

@Component({
    selector: 'app-time-log-td',
    templateUrl: './time-log-td.component.html',
    styleUrls: ['./time-log-td.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimeLogTdComponent {

    @Input() id: number;
    @Input() timer: number;
    @Input() beskrivelse: string;
    @Input() disabled = false;
    @Input() dayTotal: number;
    @Output() saveTimer = new EventEmitter<{timer: number, beskrivelse: string}>();
    @Output() saveBeskrivelse = new EventEmitter<string>();

    @ViewChild('timerInput') timerInput: ElementRef;

    constructor(
        private alert: AlertService,
        private confirm: ConfirmService
    ) {}

    keyup() {} // used to trigger change detection on value

    onChangeTimer(newValue: string, beskrivelse: string) {
        if (!newValue && !this.timer) { return; }
        const convertedValue = inputTimeToDecimal(newValue);
        if (isNaN(+convertedValue)) {
            this.alert.createAlert('Der er fejl i den indtastede værdi', 'danger');
            this.timerInput.nativeElement.focus();
            this.timerInput.nativeElement.select();
            return;
        }
        if (+convertedValue === this.timer) {
            this.timerInput.nativeElement.value = formatTime(this.timer);
            return;
        }
        if (this.dayTotal + +convertedValue - this.timer > 24) {
            this.confirm
                .question('Du har indtastet mere end 24 timer på én dag. Er dette korrekt?', 'Ja', 'Nej')
                .then(result => {
                    !result
                        ? this.timerInput.nativeElement.value = formatTime(this.timer)
                        : this.emitSaveTimer(+convertedValue, beskrivelse);
                });
        } else if (this.dayTotal + +convertedValue - this.timer < 0) {
            this.confirm
                .question('Denne indtastning vil give et negativt timeantal på dagen. Er dette korrekt?', 'Ja', 'Nej')
                .then(result => {
                    !result
                        ? this.timerInput.nativeElement.value = formatTime(this.timer)
                        : this.emitSaveTimer(+convertedValue, beskrivelse);
                });
        } else {
            this.emitSaveTimer(+convertedValue, beskrivelse);
        }
    }

    emitSaveTimer(timer: number, beskrivelse: string) {
        this.saveTimer.emit({timer, beskrivelse});
        if (timer === 0) {
            this.onChangeBeskrivelse('');
        }
    }

    onChangeBeskrivelse(newValue: string) {
        if (!newValue && !this.beskrivelse) { return; }
        if (newValue === this.beskrivelse) { return; }
        this.saveBeskrivelse.emit(newValue);
    }

}
